'use client';

import { forwardRef } from 'react';

import { Card } from '@/components/ui/card.component';
import { Skeleton } from '@/components/ui/skeleton.component';

interface CardAppointmentLoadingProps {
  isOpen?: boolean;
}

const CardAppointmentLoading = forwardRef<HTMLDivElement, CardAppointmentLoadingProps>(({ isOpen = false }, ref) => {
  return (
    <Card ref={ref} className="flex flex-col gap-4 rounded-2xl w-full">
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-3">
          <Skeleton className="h-14 w-14 rounded-lg" />
          <Skeleton className="h-5 w-48" />
        </div>

        <Skeleton className="h-5 w-3/4" />

        <hr className="border-t border-gray-200 w-full" />

        <div className="flex flex-col gap-1">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-5 w-2/3" />
        </div>

        <div className="flex flex-col gap-1">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-5 w-3/4" />
        </div>

        <div className="flex flex-col gap-1">
          <Skeleton className="h-4 w-36" />
          <Skeleton className="h-5 w-1/2" />
        </div>

        <div className="flex flex-col gap-1">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-5 w-2/5" />
          <Skeleton className="h-5 w-11/12" />
          <Skeleton className="h-5 w-1/3" />
        </div>
      </div>

      <Skeleton className="h-[52px] w-full rounded-lg" />

      {isOpen && (
        <>
          <hr className="border-t border-gray-200 w-full" />
          <div className="flex flex-col gap-1">
            <Skeleton className="h-4 w-40" />
            <Skeleton className="h-5 w-full" />
            <Skeleton className="h-5 w-5/6" />
          </div>
          <div className="flex flex-col gap-1">
            <Skeleton className="h-4 w-36" />
            <Skeleton className="h-5 w-3/4" />
            <Skeleton className="h-5 w-1/2" />
          </div>
          <div className="flex flex-col gap-1">
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-5 w-full" />
            <Skeleton className="h-5 w-full" />
            <Skeleton className="h-5 w-11/12" />
            <Skeleton className="h-5 w-2/3" />
          </div>
        </>
      )}
    </Card>
  );
});

CardAppointmentLoading.displayName = 'CardAppointmentLoading';

export default CardAppointmentLoading;
